<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="setting.stockplace_name > ''" [ttModel]="setting.stockplace_name"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'pickjobgrps_new'" (ttClick)="goToFunc('pickjobgrp')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListPickJobGroups"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-header ng-if="vm.model.setting.stockplace_name > ''" tt-model="vm.model.setting.stockplace_name"></tt-header>
        <tt-button class="col-xs-12 sp-0" tt-text="pickjobgrps_new" tt-click="vm.goToFunc('pickjobgrp')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListPickJobGroups" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
